import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  CheckoutConfig,
  CHECKOUT_CONFIG,
  WorldpayRedirectRequest,
  WorldpayRedirectResponse,
} from '@checkout/util-models';
import { map, Observable } from 'rxjs';

@Injectable()
export class WorldpayService {
  constructor(
    @Inject(CHECKOUT_CONFIG) private readonly checkoutConfig: CheckoutConfig,
    private readonly httpClient: HttpClient
  ) {}

  redirect(
    redirectRequest: WorldpayRedirectRequest
  ): Observable<WorldpayRedirectResponse> {
    return this.httpClient
      .post<{ result: WorldpayRedirectResponse }>(
        `${this.checkoutConfig.commonApi}/v2/card/payment-redirect`,
        redirectRequest
      )
      .pipe(
        map((response: { result: WorldpayRedirectResponse }) => response.result)
      );
  }
}
